import { useState } from "react";
import { Lock } from "lucide-react";
import { cardService } from "../../services/card.service";

type Props = {
  cardId: string;
  onUnlocked: () => void;
};

export function RecipientPasscodeGate({ cardId, onUnlocked }: Props) {
  const [passcode, setPasscode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const verify = async () => {
    setLoading(true);
    setError("");

    try {
      const ok = await cardService.verifyPasscode(cardId, passcode);

      if (!ok) {
        setError("That passcode is not correct.");
        return;
      }

      onUnlocked();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black px-5 text-white">
      <div className="w-full max-w-sm rounded-[30px] border border-white/10 bg-white/[0.05] p-6 text-center backdrop-blur-xl">
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-white/10 text-amber-100">
          <Lock size={20} />
        </div>

        <p className="mt-5 text-[9px] font-black uppercase tracking-[0.32em] text-white/40">
          Private passcode required
        </p>

        <h1 className="mt-3 text-2xl font-light tracking-[-0.05em]">
          This LRNSY moment is protected.
        </h1>

        <input
          type="password"
          value={passcode}
          onChange={(event) => setPasscode(event.target.value)}
          placeholder="Enter passcode"
          className="mt-6 w-full rounded-2xl border border-white/10 bg-black/30 px-4 py-4 text-center text-white outline-none placeholder:text-white/25 focus:border-amber-200/40"
        />

        {error && <p className="mt-3 text-xs text-rose-200/80">{error}</p>}

        <button
          type="button"
          disabled={loading || !passcode.trim()}
          onClick={verify}
          className="mt-5 w-full rounded-2xl bg-white px-5 py-4 text-[10px] font-black uppercase tracking-[0.22em] text-black disabled:opacity-50"
        >
          {loading ? "Checking..." : "Open private moment"}
        </button>
      </div>
    </div>
  );
}
